// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 4H16V1H18V4H22V9H2V4H6V1H8V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10.9995V22H2V10.9995H22ZM9.00391 13.4978H7V15.5017H9.00391V13.4978ZM13.0039 13.4978H11V15.5017H13.0039V13.4978ZM17.0039 13.4978H15V15.5017H17.0039V13.4978ZM9.00391 17.4978H7V19.5017H9.00391V17.4978ZM13.0039 17.4978H11V19.5017H13.0039V17.4978ZM17.0039 17.4978H15V19.5017H17.0039V17.4978Z"}}]};

const Calendar1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-1-filled',
    ref,
    icon: element,
  },
));

Calendar1FilledIcon.displayName = 'Calendar1FilledIcon';

export default Calendar1FilledIcon;
